import { Container, Step } from './styles'

export function WizardStep(props: any) {
  return <Step className={props.active ? "active": ""}>{props.text}</Step>
}

export function Wizard(props: any) {
  return <Container className={props.className}>{props.children}</Container>
}
